export const baseUrl = "https://api.faroacademic.com";
// export const baseUrl = "http://192.168.10.122:8003";
